import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Delays Pareto Graphic component
 */
export const paretoGraphicStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  gridWrapper: {
    padding: "10px",
    height: "calc(100vh - 300px)",
    minHeight: "calc(100vh - 300px)",
    width: "100%",
    margin: "0px 0 10px",
  },
});
